/**
 * Relabels the Shiprocket (Fastrr) "Buy Now" checkout button to "Proceed to Checkout"
 * in the cart drawer and on the cart page, and hides its icons.
 *
 * Shiprocket renders this button asynchronously with its own markup/font sizes, so a
 * pure-CSS relabel left the original "Buy Now" text behind. This walks the rendered
 * text nodes and replaces only the "Buy Now" label, preserving Shiprocket's elements
 * and click handlers. A MutationObserver keeps it correct if Shiprocket re-renders.
 */
(function () {
  var NEW_LABEL = "Proceed to Checkout";
  var BUY_NOW = /buy\s*now/i;

  function clean(box) {
    // Hide icon images / svgs.
    box.querySelectorAll("img, svg").forEach(function (el) {
      el.style.display = "none";
    });

    // Replace the "Buy Now" text wherever it appears, without touching structure.
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (BUY_NOW.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/buy\s*now/gi, NEW_LABEL);
      }
    }
  }

  function init() {
    var boxes = document.querySelectorAll('.shiprocket-headless[data-type="cart"]');
    boxes.forEach(function (box) {
      clean(box);
      var observer = new MutationObserver(function () {
        clean(box);
      });
      observer.observe(box, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
